// extracted by mini-css-extract-plugin
export default {"container":"KYCLevel2_container__o87aY","main-1":"KYCLevel2_main-1__5a7rr"};